<!-- 图书柜-客服 -->
<template>
  <div class="BookcaseAirlines">
    <div class="titleArea">
      <img class="logo" :src="hotlineInfo.logo_url === '' ? '/static/images/logo.png' : hotlineInfo.logo_url" alt="">
      <p class="title">{{hotlineInfo.company_desc}}</p>
    </div>
    <p class="text">客服电话：{{hotlineInfo.hotline}}</p>
    <p class="text">服务时间：{{hotlineInfo.hotline_start_time}}~{{hotlineInfo.hotline_end_time}}</p>
  </div>
</template>

<script>
  import * as config from '../../../../static/js/config.js'
  import { messageError } from '../../../../static/js/utils/utility'
  import {commonApi} from '../../../../static/js/api'
  let vm

  export default {
    name:'BookcaseAirlines',
    components: {
    },
    data() {
      return {
        hotlineInfo: {}
      }
    },
    created() {
      vm = this
      vm.getHotline()
    },
    mounted () {
      console.log('this', this.$route)
    },
    methods: {
      // 获取客服热线信息
      async getHotline () {
        let data = {
          cabinet_id: config.deviceId
        }

        let res = await commonApi.getHotline(data)
        if (res.meta.code === 200) {
          vm.hotlineInfo = res.data
        } else {
          messageError(res.meta.message)
        }
      },
      go () {
        // vm.$router.push('/Bookcase/Login')
      }
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseAirlines {
    width: 9.42rem;
    height: 12.27rem;
    margin:  0.28rem auto 0;
    background-color: #ffffff;
    box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
    .titleArea {
      width: 100%;
      margin: 0.73rem 0 3.36rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .logo {
        width: 0.91rem;
      }
      .title {
        margin-top: 0.3rem;
        font-size: 0.56rem;
        line-height: 1;
      }
    }
    .text {
      margin-left: 0.67rem;
      margin-bottom: 0.52rem;
      font-size: 0.48rem;
      line-height: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/Airlines.vue